import { render, staticRenderFns } from "./CUTextArea.vue?vue&type=template&id=7504d67a"
import script from "./CUTextArea.vue?vue&type=script&lang=ts"
export * from "./CUTextArea.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports